import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Http  } from '@angular/http';

import { SharedComponent } from '../shared/shared';

export class User {
  name: string;
  email: string;
  companyId: any;
  role : string[];


  constructor(name: string, email: string, companyId:any,role : string[]) {
    this.name = name;
    this.email = email;
    this.role=role;
    this.companyId=companyId;
  }
}

@Injectable()
export class AuthService {
  currentUser: User;
  baseUrl = this.sharedClass.baseUrl;
  headers =   this.sharedClass.header; 

  constructor(private http: Http, public sharedClass:SharedComponent){

  }


  callApi(credentials,url){
    return Observable.create(observer => {
      
      if(localStorage.getItem('deviceToken')){
        credentials.deviceToken=localStorage.getItem('deviceToken');
      }
      this.http.post(this.baseUrl+url,credentials,{headers:this.headers})
      .map(response => response.json())
      .subscribe(data => {

        if(data && data.status=="success"){
          //this.currentUser = new User(data.data.fullName, data.data.fullName,data.data.companyId,['superadmin']);
          observer.next(data);
        }else{
          observer.next(false);
        }      
        observer.complete();
      }, error => {
        console.log(error);// Error getting the data
        observer.next(false);
        observer.complete();
      });;
    });
  }


 /* secondMethod= () => {
    this.test();
  };*/

  public login(credentials) {
    //this.commonService.listenConnection();

    if (credentials.email === null || credentials.password === null) {
      return Observable.throw("Please insert credentials");
    } else {
      return this.callApi(credentials,"company/login");
    }
  }

  public register(credentials) {
    if (credentials.email === null || credentials.password === null) {
      return Observable.throw("Please insert credentials");
    } else {
      return this.callApi(credentials,"company/register");      
    }
  }

  public registerAdmin(credentials) {
    if (credentials.email === null) {
      return Observable.throw("Please insert credentials");
    } else {
      return this.callApi(credentials,"company/create_admin");      
    }
  }

  public forgotPassword(credentials) {
    if (credentials.email === null) {
      return Observable.throw("Please insert email");
    } else {
      return this.callApi(credentials,"company/forgot");      
    }
  }

  public updateUserInfo(credentials) {
    if (credentials.email === null || credentials.password === null) {
      return Observable.throw("Please insert credentials");
    } else {
      return this.callApi(credentials,"user/updateInfo"); 
    }
  }

  public updatePassword(credentials) {
    return this.callApi(credentials,"user/updatePassword"); 
  }

  public updateCompanyInfo(credentials) {
    return this.callApi(credentials,"user/updateCompanyInfo"); 
  }


  public getUserInfo() : User {
    return this.currentUser;
  }

  public logout() {
    return Observable.create(observer => {
      this.currentUser = null;
      observer.next(true);
      observer.complete();
    });
  }
}


// WEBPACK FOOTER //
// ./src/providers/auth-service.ts